import { useMemo } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { CampaignEditorState } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorState';

export const useGetEditOrActual = (): CampaignEditorState => {
  const { state } = useCampaignEditorContext();

  return useMemo(() => (state.edit ? (state.edit as CampaignEditorState) : state), [state]);
};
